module.exports = __webpack_public_path__ + "assets/retina_CutRectangleDetailed.423a7b792362b8b095fd17074e94cd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CutRectangleDetailed.png
// module id = 654
// module chunks = 0